<template>
  <div>
    <div class="d-flex justify-content-center" v-if="carregando">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <b-form ref="frmRecursos" v-if="!carregando">
      <div
        v-for="(recurso, index) in frmRecursos"
        :key="recurso.id"
        :class="[
          'd-flex justify-content-between striped p-2',
          index % 2 === 0 ? 'linha-par' : 'linha-impar'
        ]"
      >
        <p>{{ recurso.nome }}</p>
        <InputSwitch v-model="recurso.ativo"></InputSwitch>
      </div>
    </b-form>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import InputSwitch from "primevue/inputswitch";

export default {
  props: {
    conta: Object
  },

  components: {
    InputSwitch
  },

  data() {
    return {
      frmRecursos: [],
      carregando: true
    };
  },

  mounted() {
    this.abrir();
  },

  methods: {
    abrir() {
      const self = this;
      let recursos = {};
      ApiService.post("conta/obter-configuracao-recursos", {
        idConta: this.conta.id
      })
        .then((response) => {
          recursos = response.data.data;

          recursos.forEach(function (recurso) {
            recurso.ativo = recurso.recurso_ativo == "S";
          });
        })
        .then(function () {
          self.frmRecursos = recursos;

          self.carregando = false;
        })
        .then(function () {
          self.$watch(
            "frmRecursos",
            function () {
              self.$emit("aba-alterada", true);
            },
            { deep: true }
          );
        });
    },

    salvar() {
      ApiService.post("conta/salvar-configuracao-recursos", {
        idConta: this.conta.id,
        recursos: this.frmRecursos
      }).then(() => {
        this.$emit("aba-alterada", false);

        Swal.fire({
          title: "MENSAGEM",
          text: "Atualizado com sucesso!",
          icon: "success",
          heightAuto: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit("recursos-atualizados", false);
          }
        });
      });
    }
  },

  computed: {
    botaoDropdown() {
      return this.tipoBotao === "dropdown";
    }
  }
};
</script>

<style>
.linha-par {
  background-color: #f0f0f0;
}

.linha-impar {
  background-color: #ffffff;
}
</style>
